"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import DatalayerError from "@/components/client/Datalayer/DatalayerError"
import { Datalayer } from "@/components/client/Datalayer/Datalayer"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const pathname = usePathname()
  const firstSegment = pathname?.split("/").filter(Boolean)[0] || ""
  const locale = /^(?:zh-[Hh]ant-[Tt][Ww]|[a-z]{2}(?:-[A-Z]{2})?)$/.test(
    firstSegment,
  )
    ? firstSegment
    : "en"

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <DatalayerError
        errorType="500"
        errorMessage={error.message || "An unexpected error occurred"}
      />
      <Datalayer slug="500" locale={locale} siteName="500" />
      <h1 className="text-2xl font-bold">Something went wrong</h1>
      <p className="text-gray-600">
        An unexpected error occurred. Our team has been notified.
      </p>
      <div className="flex gap-4">
        <button
          onClick={reset}
          className="rounded bg-blue-trmb px-6 py-2 text-white hover:bg-blue-navy"
        >
          Try again
        </button>
        <Link
          href="/"
          className="rounded border border-gray-300 px-6 py-2 hover:bg-gray-50"
        >
          Go home
        </Link>
      </div>
    </div>
  )
}
